var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',[_vm._v(_vm._s(_vm.message.value))]),_c('span',{staticClass:"text-gray"},[_vm._v(" - "+_vm._s(_vm.message.preferred ? _vm.$t("preferred") : _vm.$t("additional")))])])}
var staticRenderFns = []

export { render, staticRenderFns }